import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function SwiftDzireOnRentInNaviMumbai() {



    const cardData = {





keyword: "Swift Dzire On Rent in Navi Mumbai",

headingDescription: "Shreesha Tours & Travels offers affordable and reliable Swift Dzire On Rent in Navi Mumbai for airport transfers, corporate travel, local transportation, business meetings, family trips, one-way journeys, round trips, and outstation travel. Our chauffeur-driven Swift Dzire provides comfortable seating, excellent mileage, smooth performance, and a budget-friendly travel option for individuals and small families. With professional drivers, clean and well-maintained cars, transparent pricing, doorstep pickup, flexible rental plans, and 24/7 customer support, we ensure a safe, comfortable, and hassle-free journey. Whether you need a cab for daily travel, airport pickup, or long-distance road trips from Navi Mumbai, Shreesha Tours & Travels provides dependable Swift Dzire rental services with complete convenience.",

topPlaces: [
  {
    title: "Navi Mumbai to Mumbai",
    description: "Mumbai is India's financial capital and a major destination for business, entertainment, shopping, and tourism. Travelers can visit Gateway of India, Marine Drive, Chhatrapati Shivaji Maharaj Terminus, Siddhivinayak Temple, and popular commercial areas. Swift Dzire on rent is an economical option for comfortable city transfers, office travel, and airport connectivity."
  },
  {
    title: "Navi Mumbai to Pune",
    description: "Pune is a major IT and education hub known for Shaniwar Wada, Aga Khan Palace, Dagdusheth Ganpati Temple, Sinhagad Fort, and modern business parks. Many travelers choose Swift Dzire for affordable and comfortable travel between Navi Mumbai and Pune for meetings, family visits, and personal work."
  },
  {
    title: "Navi Mumbai to Lonavala",
    description: "Lonavala is a famous hill station offering scenic valleys, waterfalls, Tiger Point, Bhushi Dam, Karla Caves, and beautiful monsoon views. It is one of the most preferred weekend destinations from Navi Mumbai. Swift Dzire rental provides a comfortable and economical ride for couples, families, and small groups."
  },
  {
    "title": "Navi Mumbai to Nashik",
    "description": "Nashik is a popular religious and tourist destination known for Trimbakeshwar Jyotirlinga, Panchavati, Ramkund, Sula Vineyards, and Pandavleni Caves. Visitors travel to Nashik for pilgrimage, business, and leisure purposes. Swift Dzire is a practical choice for smooth highway travel with affordable cab rates."
  },
  {
    title: "Navi Mumbai to Shirdi",
    description: "Shirdi is a famous pilgrimage destination visited by devotees of Sai Baba throughout the year. The city is known for Sai Baba Temple, Dwarkamai, Chavadi, and other spiritual attractions. Swift Dzire on rent offers a comfortable and cost-effective travel solution for small families and devotees traveling from Navi Mumbai."
  },
  {
    title: "Navi Mumbai to Alibaug",
    description: "Alibaug is a beautiful coastal getaway known for beaches, Kolaba Fort, water sports, seafood, and relaxing resorts. It is a perfect destination for short vacations and weekend trips. A Swift Dzire cab provides convenient travel for couples and small families looking for an affordable beach trip."
  },
  {
    title: "Navi Mumbai to Matheran",
    description: "Matheran is a peaceful hill station famous for toy train rides, viewpoints, Charlotte Lake, Echo Point, and lush green surroundings. Since vehicles are restricted inside Matheran, travelers prefer comfortable cabs till the entry point. Swift Dzire rental is suitable for budget-friendly hill station travel."
  },
  {
    title: "Navi Mumbai to Igatpuri",
    description: "Igatpuri is a scenic destination in the Western Ghats known for waterfalls, Camel Valley, Vipassana International Academy, trekking routes, and beautiful mountain views. It is a popular weekend escape from Navi Mumbai. Swift Dzire offers an economical and comfortable journey for nature lovers."
  },
  {
    title: "Navi Mumbai to Bhandardara",
    description: "Bhandardara is a peaceful nature destination famous for Arthur Lake, Randha Waterfall, Wilson Dam, and beautiful Sahyadri landscapes. Travelers visit this place for camping, photography, and relaxing holidays. Swift Dzire rental makes the journey convenient and affordable for small groups."
  },
  {
    title: "Navi Mumbai to Saputara",
    description: "Saputara is Gujarat's beautiful hill station known for Saputara Lake, Sunset Point, Ropeway, Gira Waterfalls, and scenic green valleys. It is a perfect destination for family outings and nature trips. Swift Dzire on rent provides a comfortable travel experience with budget-friendly pricing."
  }
],


"services": [
  {
    "name": "Swift Dzire on Rent in Mumbai",
    "description": "Book Swift Dzire on Rent in Mumbai for affordable and comfortable chauffeur-driven travel. Choose Swift Dzire rental services for airport transfers, corporate travel, local rides, family trips, and outstation journeys with clean AC vehicles and professional drivers."
  },
  {
    "name": "Swift Dzire on Rent in Navi Mumbai",
    "description": "Reserve Swift Dzire on Rent in Navi Mumbai for reliable transportation with experienced chauffeurs, comfortable seating, and well-maintained vehicles for local and long-distance travel."
  },
  {
    "name": "Swift Dzire Rental Navi Mumbai",
    "description": "Choose Swift Dzire Rental Navi Mumbai for budget-friendly travel with professional drivers, transparent pricing, and comfortable AC sedan vehicles."
  },
  {
    "name": "Swift Dzire Hire in Navi Mumbai",
    "description": "Book Swift Dzire Hire in Navi Mumbai for business travel, airport transfers, family trips, and outstation journeys with reliable chauffeur service."
  },
  {
    "name": "Swift Dzire Car Rental Navi Mumbai",
    "description": "Reserve Swift Dzire Car Rental Navi Mumbai for economical travel with clean interiors, experienced drivers, and flexible rental options."
  },
  {
    "name": "Swift Dzire Taxi Service Navi Mumbai",
    "description": "Choose Swift Dzire Taxi Service Navi Mumbai for comfortable local and outstation transportation with professional chauffeurs and affordable fares."
  },
  {
    "name": "Book Swift Dzire on Rent in Navi Mumbai",
    "description": "Book Swift Dzire on Rent in Navi Mumbai online with instant confirmation, flexible pickup timings, transparent pricing, and 24x7 support."
  },
  {
    "name": "Best Swift Dzire on Rent Navi Mumbai",
    "description": "Select the Best Swift Dzire on Rent Navi Mumbai for reliable travel with sanitized vehicles, experienced chauffeurs, and excellent customer service."
  },
  {
    "name": "Cheapest Swift Dzire Rental Navi Mumbai",
    "description": "Book Cheapest Swift Dzire Rental Navi Mumbai with affordable pricing, comfortable sedan vehicles, and dependable chauffeur-driven service."
  },
  {
    "name": "Swift Dzire on Rent with Driver Navi Mumbai",
    "description": "Choose Swift Dzire on Rent with Driver Navi Mumbai for hassle-free travel with trained chauffeurs, clean vehicles, and comfortable rides."
  },
  {
    "name": "Swift Dzire Rental Service Navi Mumbai",
    "description": "Reserve Swift Dzire Rental Service Navi Mumbai for airport transfers, corporate travel, family trips, and outstation journeys with reliable service."
  },
  {
    "name": "Swift Dzire Airport Pickup Navi Mumbai",
    "description": "Book Swift Dzire Airport Pickup Navi Mumbai for timely airport arrivals with professional drivers, luggage assistance, and comfortable AC sedan travel."
  },
  {
    "name": "Swift Dzire Airport Drop Navi Mumbai",
    "description": "Choose Swift Dzire Airport Drop Navi Mumbai for punctual airport transfers with experienced chauffeurs and convenient transportation."
  },
  {
    "name": "Swift Dzire Outstation Rental Navi Mumbai",
    "description": "Reserve Swift Dzire Outstation Rental Navi Mumbai for one-way and round-trip travel with affordable fares, comfortable seating, and reliable drivers."
  },
  {
    "name": "Swift Dzire Cab for Outstation Navi Mumbai",
    "description": "Book Swift Dzire Cab for Outstation Navi Mumbai for long-distance journeys with AC comfort, professional chauffeurs, and smooth travel."
  },
  {
    "name": "Swift Dzire on Rent in Vashi",
    "description": "Choose Swift Dzire on Rent in Vashi for local rides, airport transfers, office travel, and outstation trips with reliable chauffeur service."
  },
  {
    "name": "Swift Dzire on Rent in Nerul",
    "description": "Book Swift Dzire on Rent in Nerul for affordable transportation with clean AC vehicles, experienced drivers, and flexible rental options."
  },
  {
    "name": "Swift Dzire on Rent in Kharghar",
    "description": "Reserve Swift Dzire on Rent in Kharghar for comfortable city travel, airport transfers, and outstation journeys with professional chauffeurs."
  },
  {
    "name": "Swift Dzire on Rent in Panvel",
    "description": "Choose Swift Dzire on Rent in Panvel for budget-friendly travel with reliable drivers and well-maintained sedan vehicles."
  }
],
"tableData": [
  ["Swift Dzire on Rent in Mumbai", "Swift Dzire on Rent in Navi Mumbai"],
  ["Swift Dzire Rental Navi Mumbai", "Swift Dzire Hire in Navi Mumbai"],
  ["Swift Dzire Car Rental Navi Mumbai", "Swift Dzire Taxi Service Navi Mumbai"],
  ["Book Swift Dzire on Rent in Navi Mumbai", "Best Swift Dzire on Rent Navi Mumbai"],
  ["Cheapest Swift Dzire Rental Navi Mumbai", "Swift Dzire on Rent with Driver Navi Mumbai"],
  ["Swift Dzire Rental Service Navi Mumbai", "Swift Dzire Airport Pickup Navi Mumbai"],
  ["Swift Dzire Airport Drop Navi Mumbai", "Swift Dzire Outstation Rental Navi Mumbai"],
  ["Swift Dzire Cab for Outstation Navi Mumbai", "Swift Dzire on Rent in Vashi"],
  ["Swift Dzire on Rent in Nerul", "Swift Dzire on Rent in Kharghar"],
  ["Swift Dzire on Rent in Panvel", ""]
],




whychoose: [
  {
    WhyChooseheading: "Affordable Swift Dzire on Rent in Navi Mumbai",
    WhyChoosedescription: "Shreesha Travels offers Swift Dzire on rent in Navi Mumbai for local travel, airport transfers, corporate rides, outstation trips, and personal transportation. Enjoy a comfortable sedan experience with professional chauffeur service and budget-friendly rental options."
  },
  {
    WhyChooseheading: "Comfortable Sedan for Daily & Outstation Travel",
    WhyChoosedescription: "Maruti Swift Dzire is a popular choice for passengers looking for a reliable sedan with comfortable seating, smooth performance, air conditioning, and sufficient luggage space for every journey."
  },
  {
    WhyChooseheading: "Available for Local, Airport & Outstation Trips",
    WhyChoosedescription: "Hire a Swift Dzire for Navi Mumbai city travel, Mumbai Airport transfers, Navi Mumbai Airport pickups, office meetings, one-way drops, round trips, and long-distance journeys across Maharashtra."
  },
  {
    WhyChooseheading: "Budget-Friendly Rental Packages",
    WhyChoosedescription: "Choose from hourly rentals, full-day packages, airport transfer services, one-way cab bookings, round trips, and customized travel plans according to your budget and travel schedule."
  },
  {
    WhyChooseheading: "Professional Chauffeurs for Safe Travel",
    WhyChoosedescription: "Our experienced drivers are familiar with Navi Mumbai, Mumbai city roads, highways, and popular routes, ensuring punctual pickups, safe driving, and a comfortable ride."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Swift Dzire Cars",
    WhyChoosedescription: "Every Swift Dzire is regularly serviced, sanitized, air-conditioned, and inspected before every trip to provide passengers with a reliable and pleasant travel experience."
  },
  {
    WhyChooseheading: "Ideal for Business & Personal Transportation",
    WhyChoosedescription: "Our Swift Dzire rental service is suitable for corporate meetings, employee travel, airport transfers, hotel pickups, sightseeing, family visits, and daily transportation needs."
  },
  {
    WhyChooseheading: "Book Swift Dzire on Rent in Navi Mumbai with Shreesha Travels",
    WhyChoosedescription: "Get affordable sedan rental options, quick booking assistance, professional chauffeur service, and dependable Swift Dzire cars for local and outstation travel."
  }
]

};

const faqData = [
  {
    question: "Can I rent a Swift Dzire in Navi Mumbai?",
    answer: "Yes, Swift Dzire is available on rent in Navi Mumbai for local rides, airport transfers, corporate travel, and outstation journeys."
  },
  {
    question: "Is Swift Dzire available for outstation trips?",
    answer: "Yes, you can book Swift Dzire for one-way, round-trip, and multi-day outstation travel from Navi Mumbai."
  },
  {
    question: "Do you provide Swift Dzire for airport transfers?",
    answer: "Yes, Swift Dzire rental is available for Mumbai Airport and Navi Mumbai Airport pickup and drop services."
  },
  {
    question: "Is Swift Dzire suitable for business travel?",
    answer: "Yes, the sedan is suitable for corporate meetings, office visits, client transportation, and executive travel."
  },
  {
    question: "Can I hire Swift Dzire with a driver?",
    answer: "Yes, every Swift Dzire rental includes a professional chauffeur for safe and comfortable travel."
  },
  {
    question: "Can I book Swift Dzire for full-day rental?",
    answer: "Yes, full-day and hourly rental packages are available for sightseeing, business travel, and personal use."
  },
  {
    question: "How is the Swift Dzire rental fare calculated?",
    answer: "The rental fare depends on travel distance, duration, vehicle package, toll charges, parking fees, and additional requirements."
  },
  {
    question: "Can I book Swift Dzire for wedding or special events?",
    answer: "Yes, Swift Dzire can be booked for guest transportation, family functions, hotel transfers, and special occasions."
  },
  {
    question: "Are Swift Dzire cars available 24x7 in Navi Mumbai?",
    answer: "Yes, bookings are available throughout the day according to your scheduled travel requirements."
  },
  {
    question: "How can I book Swift Dzire on Rent in Navi Mumbai with Shreesha Travels?",
    answer: "Share your pickup location, travel date, destination, passenger details, and rental requirement to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Joshi",
    feedback: "I booked a Swift Dzire for local travel in Navi Mumbai. The car was clean, comfortable, and the driver arrived on time. Excellent service experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Patil",
    feedback: "The Swift Dzire rental service was affordable and convenient. The chauffeur was professional, and our airport transfer was smooth and comfortable.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire On Rent in Navi Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/swift-dzire-on-rent-in-navi-mumbai.webp",
  "description":
    "Book Swift Dzire On Rent in Navi Mumbai with Shreesha Tours & Travels for affordable and comfortable taxi services. We provide Maruti Swift Dzire cabs with experienced drivers for local travel, airport transfers, outstation trips, business travel, family trips, and long-distance journeys with 24x7 booking.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/swift-dzire-on-rent-in-navi-mumbai"
  }
};




    return (
        <div>
<Helmet>
  <title>Swift Dzire On Rent in Navi Mumbai | Dzire Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Swift Dzire On Rent in Navi Mumbai with Shreesha Travels for safe and comfortable taxi services. Hire Maruti Swift Dzire with experienced drivers for local travel, airport transfers, outstation trips, corporate travel, family tours, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Swift Dzire On Rent in Mumbai, Swift Dzire On Rent in Navi Mumbai, Swift Dzire Rental Navi Mumbai, Swift Dzire Hire in Navi Mumbai, Swift Dzire Car Rental Navi Mumbai, Swift Dzire Taxi Service Navi Mumbai, Swift Dzire Cab Booking Navi Mumbai, Swift Dzire With Driver Navi Mumbai, Swift Dzire Airport Taxi Navi Mumbai, Swift Dzire Outstation Cab Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/98.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default SwiftDzireOnRentInNaviMumbai;